import PreviewSectionCard from './PreviewSectionCard';
import PreviewBadge from './PreviewBadge';

const gridClasses = 'grid grid-cols-1 md:grid-cols-3 gap-4';

const routeBaseClasses = 'rounded-xl border p-5 flex flex-col gap-2';

const routeToneClasses = {
    neutral: 'border-border bg-surface-alt',
    primary: 'border-primary bg-primary-surface ring-1 ring-primary/30',
};

const routeTitleClasses = 'text-base font-bold text-content m-0';

const routeDescriptionClasses = 'text-sm text-subtle m-0';

const routeBestForClasses = 'text-xs font-semibold text-primary m-0 mt-auto pt-1';

const RecommendedRouteCard = ({ routes }) => (
    <PreviewSectionCard
        title="Recommended Route"
        badge={<PreviewBadge tone="warning">Preliminary first</PreviewBadge>}
    >
        <div className={gridClasses}>
            {routes.map((route) => (
                <div key={route.key} className={`${routeBaseClasses} ${routeToneClasses[route.tone] || routeToneClasses.neutral}`}>
                    <PreviewBadge tone={route.tone === 'primary' ? 'primary' : 'neutral'}>{route.tag}</PreviewBadge>
                    <p className={routeTitleClasses}>{route.title}</p>
                    <p className={routeDescriptionClasses}>{route.description}</p>
                    <p className={routeBestForClasses}>{route.bestFor}</p>
                </div>
            ))}
        </div>
    </PreviewSectionCard>
);

export default RecommendedRouteCard;
